import { render, staticRenderFns } from "./IrisInputDropdown.vue?vue&type=template&id=891c3dd8&"
import script from "./IrisInputDropdown.vue?vue&type=script&lang=ts&"
export * from "./IrisInputDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./IrisInputDropdown.vue?vue&type=style&index=0&id=891c3dd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports